









import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PartBox: () => import('@/layouts/parts/box.vue'),
  },
})
export default class PagePresetGuest extends Vue {}
